"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedStore = void 0;
var mobx_1 = require("mobx");
var domainToRegex = function (domain) {
    return new RegExp("^" + domain.replace(/\./g, "\\.").replace(/\*/g, ".*") + "$");
};
var SharedStore = /** @class */ (function () {
    function SharedStore() {
        var _this = this;
        Object.defineProperty(this, "allowedDomains", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "zoomImageData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setAllowedDomains", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (domains) {
                (0, mobx_1.runInAction)(function () {
                    _this.allowedDomains = domains;
                });
            }
        });
        Object.defineProperty(this, "isAllowedUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (url) {
                try {
                    var hostname_1 = new URL(url).hostname;
                    return _this.allowedDomains.some(function (domain) {
                        var domainRegex = domainToRegex(domain);
                        return domainRegex.test(hostname_1);
                    });
                }
                catch (error) {
                    console.error("Invalid URL:", error);
                    return false;
                }
            }
        });
        Object.defineProperty(this, "showZoomImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (data) {
                (0, mobx_1.runInAction)(function () {
                    data.show = true;
                    _this.zoomImageData = data;
                });
            }
        });
        Object.defineProperty(this, "hideZoomImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                (0, mobx_1.runInAction)(function () {
                    _this.zoomImageData.show = false;
                });
            }
        });
        (0, mobx_1.makeObservable)(this, {
            allowedDomains: mobx_1.observable,
            zoomImageData: mobx_1.observable
        });
    }
    return SharedStore;
}());
exports.SharedStore = SharedStore;
exports.default = new SharedStore();
